export interface STAddress {
    street?: string;
    streetAddress?: string;
    city?: string;
    state?: string;
    zip?: string;
}

export interface ServiceAddress {
    id: number;
    name: string;
    text: string;
    data: STAddress;
}

export const formatAddress = (address: STAddress) =>
    [address.streetAddress ?? address.street, address.city, address.state, address.zip]
        .filter(i => !!i)
        .join(', ');

export const createServiceAddress = (
    id: number,
    name: string,
    address: STAddress,
    text?: string
): ServiceAddress => ({
    id,
    name,
    data: address,
    text: text ?? formatAddress(address),
});

export class ServiceAddressStore {
    private idCounter = 1;
    private allAddresses: ServiceAddress[] = [];

    get addresses() {
        return [...this.allAddresses];
    }

    addAddress(name: string, address: undefined): undefined;
    addAddress(name: string, address: STAddress): ServiceAddress;
    addAddress(name: string, address?: STAddress | undefined): ServiceAddress | undefined {
        if (!address) {
            return undefined;
        }

        const text = formatAddress(address);
        const existed = this.allAddresses.find(add => add.text === text && add.name === name);

        if (existed) {
            return existed;
        }

        const add = createServiceAddress(this.idCounter++, name ?? '', address, text);

        this.allAddresses.push(add);

        return add;
    }

    get(id: number): ServiceAddress | undefined {
        return this.allAddresses.find(a => a.id === id);
    }
}
